export const ADDON_TYPES = {
  ADDON: 'ADDON',
  SUB_ADDON: 'SUB_ADDON',
};

